export const getserver = () => {
  const server = "https://shopstopAPI.onrender.com";
  // const server = "http://localhost:3001";
  return server;
};
